/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 22.10.17.
 */
import update from 'immutability-helper';
import _ from "underscore";
import SimpleHelper from "./SimpleHelper";
import t from "../../trans";

/**
 * Performs change in person object "personRoleCollection".
 * In addition to usual object item change performs also control of "isDefault" field. If this field is set on
 * changeable item then all other items will get false value for this field.
 */
class PersonRoleCollectionHelper extends SimpleHelper {
    /**
     * Apply change to the array data
     * @param {string} action Action to perform to the data. One of: "insert", "update", "delete".
     * @param {Array} oldValue Old value
     * @param {Object} newValue New value
     * @param {Schema} schema Schema object for this data
     * @returns {Array} Returns changed data. If there were errors then resulted value is null and method
     * isError() returns true. NB! It is possible, that returned value is null and there are no errors! This is normal -
     * this means that assigned value should be null.
     */
    applyArrayAction(action, oldValue, newValue, schema) {
        let spec = this.makeArrayActionUpdateSpec(action, oldValue, newValue, schema);
        if (!spec) return null;

        if (action !== "update" && newValue.isDefault) {
            // First we should remove "isDefault" from old items
            oldValue = this.removeIsDefault(oldValue);
        }

        return update(oldValue, spec);
    }

    removeIsDefault(oldValue) {
        if (oldValue == null) return oldValue;
        for (let i = 0; i < oldValue.length; i++) {
            if (oldValue[i].isDefault) {
                oldValue = update(oldValue, {[i]: {isDefault: {$set: false}}});
            }
        }
        return oldValue;
    }
}

export default PersonRoleCollectionHelper;
